<div class="wrapper">

  <!-- Navbar -->
  <nav class="main-header2 fixed-top navbar navbar-expand navbar-light p-0">
    <div class="container-fluid">
      <div class="row w-100">
        <div class="col-3 col-md-3 text-left">
           <!--<a class="nav-link push-icon-container" data-widget="pushmenu" href="#" role="button" style="max-width: 120px">
            <i class="fas fa-2x fa-bars push-icon p-3" style="max-width: 60px"></i>
          </a>-->
          <button id="btnmenuMobile" class="fas fa-2x p-3 " style="border:none;background-color:transparent !important">
            <img src="../../assets/images/hamburger_icon1.png" width="40px" height="40px" alt="">
            <img src="../../assets/images/hamburger_icon2.png" width="40px" height="40px" alt="" class="imgToggle">
          </button>
        </div>
        <div class="col-6  col-md-6 text-center my-auto">
          <a class="navbar-brand" style="display: flex; justify-content: center;">
            <img src="../../assets/images/img_logo.png" alt="DPA" class="brand-image main-logo" (click)="goToIndex()">
          </a>
        </div>
        <div class="col-3 col-md-3">
          <div class="row">
            <div class="col-12 col-md-6 offset-md-6 text-right" style="height: 28px !important;">
               <!--<button class="btn p-0 pt-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <label style="font-size: 13px;" class="d-none d-sm-block" *ngIf="lang!='th'" translate>
                  <img src="../../assets/images/img_{{lang}}.png" style="height: 13px;">
                  ENGLISH
                </label>
                <label style="font-size: 13px;" class="d-none d-sm-block" *ngIf="lang=='th'" translate>
                  <img src="../../assets/images/img_{{lang}}.png" style="height: 13px;">
                  THAI
                </label>
                <img class="d-block d-sm-none" src="../../assets/images/img_{{lang}}.png" style="height: 13px;">
              </button>
              <div class="dropdown-menu pt-0 pb-1 dropdown-menu-right" aria-labelledby="dropdownMenuButton" style="margin-top: -5px;">
                <a (click)="setLanguage('th-TH')" class="dropdown-item btn-lang" id="langth-TH" *ngIf="lang!='th'">
                  <img src="../../assets/images/img_th.png">
                  <label translate>THAI</label>
                </a>
                <a (click)="setLanguage('en-US')" class="dropdown-item btn-lang" id="langen-US" *ngIf="lang=='th'">
                  <img src="../../assets/images/img_en.png">
                  <label translate>ENGLISH</label>
                </a>
              </div>-->

            </div>
            
            <div class="col-12 text-right">
              <a href="mainmenu/login" *ngIf="!isLoggedIn && regisMenu.show">
                <i *ngIf="lang == 'en'" class="d-none d-sm-block">{{regisMenu.dpa_name}}</i>
                <i *ngIf="lang == 'th'" class="d-none d-sm-block">{{regisMenu.dpa_menu_th}}</i>
                <i class="fa fa-user login-btn"></i>
              </a>

              <ul class="navbar-nav" style="line-height: 70px; vertical-align: middle; float: right;" *ngIf="isLoggedIn">
                <li class="dropdown user user-menu open">
                  <a class="btn btn-link text-primary" data-toggle="dropdown" aria-expanded="true">
                    <img
                      src="{{imgProfileSrc != null && imgProfileSrc != '' ? imgProfileSrc : '../../assets/images/profileIcon.png'}}"
                      class="user-image" alt="User Image">
                  </a>

                  <ul class="dropdown-menu dropleft" style="line-height: 3;">
                    <li class="user-header">
                      <img
                        src="{{imgProfileSrc != null && imgProfileSrc != '' ? imgProfileSrc : '../../assets/images/profile.png'}}"
                        class="img-circle" alt="User Image">
                      <p class="m-0 p-0">
                        {{firstname}} {{lastname}}
                      </p>
                    </li>
                    <li class="user-body m-0 p-0">
                      <div class="row">
                        <div class="col-12 text-center">
                          <button class="btn btn-link w-100  m-0 p-0" (click)="goToProfile()" translate>Profile</button>
                        </div>
                        <hr class="w-100 m-0">
                        <div class="col-12 text-center">
                          <button class="btn btn-link text-danger w-100 m-0 p-0" (click)="signOut()" translate>Signout</button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  
  <!-- /.navbar -->
 <!-- main-sidebar -->
  <aside class="  fixed-top sidebar-light-primary elevation-4" style="margin-top: -350px;">

    <div class="row" style="height: 0px !important;display: none;">
      <div class="col-10 my-auto" style="height: fit-content !important;">
        <a class="" style="display: flex; justify-content: center; cursor: pointer;">
          <img src="../../assets/images/img_logo.png" alt="DPA" class="brand-image img-circle main-logo" class="w-100"
            (click)="goToIndex()">
        </a>
      </div>
      <div class="col-2 p-0" style="float: right;">
        <a class="nav-link close-push-icon" data-widget="pushmenu" href="#" role="button" style="padding: 10 px;">
          <i class="fa fa-times"></i>
        </a>
      </div>
    </div>
    <hr class="w-100 m-0">
    <div
      class="sidebar os-host os-theme-light os-host-overflow os-host-overflow-y os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition">
      <div class="os-resize-observer-host">
        <div class="os-resize-observer observed" style="left: 0px; right: auto;"></div>
      </div>
      <div class="os-size-auto-observer" style="height: calc(100% + 1px); float: left;">
        <div class="os-resize-observer observed"></div>
      </div>
      <div class="os-content-glue" style=" width: 73px; height: 35px;"></div>
      <div class="os-padding">
        <div class="os-viewport os-viewport-native-scrollbars-invisible">
          <div class="os-content" style=" height: 100%; width: 100%;">
            <nav class="mt-2">
              <ul class="nav nav-pills nav-sidebar nav-child-indent flex-column" data-widget="treeview" role="menu">

                <li class="nav-item" *ngIf="aboutUsMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToAboutUs()">{{aboutUsMenu.dpa_name}}</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToAboutUs()">{{aboutUsMenu.dpa_menu_th}}</a>
                </li>
                 <!-- <li class="nav-item">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToNews()">News</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToNews()">ข่าวสาร</a>
                </li> -->
                <li class="nav-item" *ngIf="loginMenu.show && !isLoggedIn">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToLogin()">{{loginMenu.dpa_name}}</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToLogin()">{{loginMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="simulateMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('simulate')">{{simulateMenu.dpa_name}}</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('simulate')">{{simulateMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="trackStatusMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('statusTracking')">{{trackStatusMenu.dpa_name}}</a>
                  <a id="a_statusTracking"  class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('statusTracking')">{{trackStatusMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="inquiryMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('refundDeposits')">{{inquiryMenu.dpa_name}}</a>
                  <a id="a_refundDeposits"  class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('refundDeposits')">{{inquiryMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="reqNewDocMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('reqNewDocument')">{{reqNewDocMenu.dpa_name}}</a>
                  <a id="a_reqNewDocument" class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('reqNewDocument')">{{reqNewDocMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="statusReqNewDocMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('statusReqNewDocument')">{{statusReqNewDocMenu.dpa_name}}</a>
                  <a id="a_statusReqNewDocument" class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('statusReqNewDocument')">{{statusReqNewDocMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="contactDpaMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToContactDpa()">{{contactDpaMenu.dpa_name}}</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToContactDpa()">{{contactDpaMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="faqMenu.show">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToFaq()">{{faqMenu.dpa_name}}</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToFaq()">{{faqMenu.dpa_menu_th}}</a>
                </li>
                <li class="nav-item" *ngIf="isLoggedIn">
                  <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="signOut()">Logout</a>
                  <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="signOut()">ออกจากระบบ</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="os-scrollbar os-scrollbar-horizontal os-scrollbar-unusable os-scrollbar-auto-hidden">
        <div class="os-scrollbar-track">
          <div class="os-scrollbar-handle" style="width: 100%; transform: translate(0px, 0px);"></div>
        </div>
      </div>
      <div class="os-scrollbar os-scrollbar-vertical os-scrollbar-auto-hidden">
        <div class="os-scrollbar-track">
          <div class="os-scrollbar-handle" style="height: 10.6651%; transform: translate(0px, 0px);"></div>
        </div>
      </div>
      <div class="os-scrollbar-corner"></div>
    </div>
  </aside>

  
  <div class="header-bot" style="padding-top: 90px;">
    <div class="container-xl">
      <div class="header-bot--wrap">
        <nav class="header-bot-nav ">
          <ul>

            <li *ngIf="aboutUsMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToAboutUs()">{{aboutUsMenu.dpa_name}}</a>
              <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToAboutUs()">{{aboutUsMenu.dpa_menu_th}}</a>
            </li>
            <li  *ngIf="loginMenu.show && !isLoggedIn">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToLogin()">{{loginMenu.dpa_name}}</a>
              <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToLogin()">{{loginMenu.dpa_menu_th}}</a>
            </li>
            <li  *ngIf="simulateMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('simulate')">{{simulateMenu.dpa_name}}</a>
              <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('simulate')">{{simulateMenu.dpa_menu_th}}</a>
            </li>
            <li  *ngIf="trackStatusMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('statusTracking')">{{trackStatusMenu.dpa_name}}</a>
              <a id="b_statusTracking" class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('statusTracking')">{{trackStatusMenu.dpa_menu_th}}</a>
            </li>
            <li  *ngIf="inquiryMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('refundDeposits')">{{inquiryMenu.dpa_name}}</a>
              <a id="b_refundDeposits" class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('refundDeposits')">{{inquiryMenu.dpa_menu_th}}</a>
            </li>
            <li *ngIf="reqNewDocMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('reqNewDocument')">{{reqNewDocMenu.dpa_name}}</a>
              <a id="b_reqNewDocument" class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('reqNewDocument')">{{reqNewDocMenu.dpa_menu_th}}</a>
            </li>
            <li *ngIf="statusReqNewDocMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToMenuClick('statusReqNewDocument')">{{statusReqNewDocMenu.dpa_name}}</a>
              <a id="b_statusReqNewDocument" class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('statusReqNewDocument')">{{statusReqNewDocMenu.dpa_menu_th}}</a>
            </li>
            <li  *ngIf="contactDpaMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToContactDpa()">{{contactDpaMenu.dpa_name}}</a>
              <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToContactDpa()">{{contactDpaMenu.dpa_menu_th}}</a>
            </li>
            <li *ngIf="faqMenu.show">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="goToFaq()">{{faqMenu.dpa_name}}</a>
              <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="goToFaq()">{{faqMenu.dpa_menu_th}}</a>
            </li>
            <li  *ngIf="isLoggedIn">
              <a class="nav-link user-menu" *ngIf="lang == 'en'" (click)="signOut()">Logout</a>
              <a class="nav-link user-menu" *ngIf="lang == 'th'" (click)="signOut()">ออกจากระบบ</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <div class="wrappermaster main-body" style="padding-top: 90px;">

    <router-outlet></router-outlet>
    
  </div>

  <!-- ./wrapper -->
  <!-- </div> -->

   <!-- <div class="footer-area p-0">
    - สถาบันคุ้มครองเงินฝาก : Deposit Protection Agency - All Rights Reserved
  </div>-->
  <footer id="footer" class="main-footer-DPA footer-custom" style="margin-left: 0px !important;">
    <div class="footer-dpa container-xl-footer">
      <div class="footer-body text-white" >
        <!--  <div class="accordion" id="accordionFooter" style="display: none;">
            <div class="accordion-item">
                <h6 class="accordion-header ">
                  <a class="user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('statusTracking')">
                    <div class="accordion-button no-menu text-white" type="button">
                      {{trackStatusMenu.dpa_menu_th}}
                    </div>
                  </a>
                </h6>
            </div>
            <div class="accordion-item">
              <h6 class="accordion-header ">
                <a class="user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('refundDeposits')">
                  <div class="accordion-button no-menu text-white" type="button">
                    {{inquiryMenu.dpa_menu_th}}
                  </div>
                </a>
              </h6>
            </div>
            <div class="accordion-item">
              <h6 class="accordion-header ">
                <a class="user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('reqNewDocument')">
                  <div class="accordion-button no-menu text-white" type="button">
                    {{reqNewDocMenu.dpa_menu_th}}
                  </div>
                </a>
              </h6>
            </div>
            <div class="accordion-item" style="display: none;">
              <h6 class="accordion-header ">
                <a class="user-menu" *ngIf="lang == 'th'" (click)="goToMenuClick('statusReqNewDocument')">
                  <div class="accordion-button no-menu text-white" type="button">
                    {{statusReqNewDocMenu.dpa_menu_th}}
                  </div>
                </a>
              </h6>
            </div>
            <div class="accordion-item">
              <h6 class="accordion-header ">
                <a class="user-menu" *ngIf="lang == 'th'" (click)="goToContactDpa()">
                  <div class="accordion-button no-menu text-white" type="button">
                    {{contactDpaMenu.dpa_menu_th}}
                  </div>
                </a>
              </h6>
            </div>
            <div class="accordion-item">
              <h6 class="accordion-header ">
                <a class="user-menu" *ngIf="lang == 'th'" (click)="goToFaq()">
                  <div class="accordion-button no-menu text-white" type="button">
                    {{faqMenu.dpa_menu_th}}
                  </div>
                </a>
              </h6>
            </div>
        </div>-->
      
        <div class="left">
          <div class="footer-mid-head" >
              <h6 style="font-weight:600 !important">สถาบันคุ้มครองเงินฝาก</h6>
          </div>
          <div class="footer-mid-address">
            <span>
              อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br>ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br>แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900
            </span>
        </div>
        </div>
      </div>
      <div class="footer-mid text-white ">
          
          <div class="right">
            <div class="footer-mid-contact">
              <span style="font-weight:600 !important">สถาบันคุ้มครองเงินฝาก</span>
                <div class="social">
                  <a href="https://www.facebook.com/dpathailand" target="_blank" aria-label="Facebook">
                    <img src="../../assets/images/social_facebook.png" width="32" height="32"  />
                  </a>
                  
                  <a href="https://twitter.com/DPAThailand" target="_blank" aria-label="X">
                    <img src="../../assets/images/social_twitter.png" width="32" height="32"  />
                  </a>
                  <a href="https://page.line.me/dpathailand" target="_blank" aria-label="LINE">
                    <img src="../../assets/images/social_line.png" width="32" height="32" />
                  </a>
                  <a href="https://www.youtube.com/@dpathailand" target="_blank" aria-label="Youtube">
                    <img src="../../assets/images/social_youtube.png" width="32" height="32" />
                  </a>
                  <a href="https://th.linkedin.com/in/dpa-deposit-protection-agency-2a3797260" target="_blank" aria-label="LinkedIn">
                    <img src="../../assets/images/social_linkedin.png" width="32" height="32" />
                  </a>
      
                </div>
            </div>
            <div class="footer-mid-tel" style="padding-top: 30px;">
              <span style="font-weight:600 !important">ศูนย์ข้อมูลคุ้มครองเงินฝาก</span>
                <div class="tel">
                  <a href="tel:1158">
                    <img src="../../assets/images/tel_1158.png" alt="CCLogo" class="img-callcenter"
                    onmouseout="this.src='../../assets/images/tel_1158.png'"  />
                  </a>
      
                </div>
            </div>
          </div>
      </div>
    </div>
    <div class="bg-white-footer row">
      <div class="col-1"></div>
      <div class="col-11 footer-bottom-copyright text-primary-dpa">
        <small>© Copyright 2024 - สถาบันคุ้มครองเงินฝาก : Deposit Protection Agency - All Rights Reserved</small>
    </div>
    </div>
  </footer>
</div>


// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.html